import i18next from 'i18next';

/**
 * Bot upload terminal states. Backend string values — keep
 * lowercase, must match API responses.
 */
export const BOT_UPLOADS_STATUSES = {
  success: 'success',
  error: 'error',
  pending: 'pending',
};

/**
 * Display-ready options for the bot-upload status filter dropdown.
 * Labels are resolved via i18next at module load time — translations
 * must be initialised before this module is imported.
 */
export const BOT_UPLOADS_STATUSES_OPTIONS = [
  { label: i18next.t('tables:success'), value: BOT_UPLOADS_STATUSES.success },
  { label: i18next.t('tables:error'), value: BOT_UPLOADS_STATUSES.error },
  { label: i18next.t('tables:pending'), value: BOT_UPLOADS_STATUSES.pending },
];

/**
 * Document types a bot can upload for one assessment. The API returns
 * one row per document, so a single assessment yields an `assessment`
 * row, a `programReport` row and — only once it has been queued — one
 * `counselingReport` row per bot integration.
 *
 * Backend enum strings, case-sensitive; the grid base64-encodes them
 * into the filter query, so they must match the stored values exactly.
 */
export const DOCUMENT_TYPES = {
  assessment: 'assessment',
  programReport: 'programReport',
  counselingReport: 'counselingReport',
};

export const DOCUMENT_TYPES_OPTIONS = [
  { label: i18next.t('tables:documentTypeAssessment'), value: DOCUMENT_TYPES.assessment },
  { label: i18next.t('tables:documentTypeProgramReport'), value: DOCUMENT_TYPES.programReport },
  {
    label: i18next.t('tables:documentTypeCounselingReport'),
    value: DOCUMENT_TYPES.counselingReport,
  },
];

// The EHR integrations a document can be uploaded to are deliberately
// NOT listed here. `/lookups/botActivities?fields=botIntegration`
// returns the bots that actually appear on the rows, so the Bot column
// uses the dynamic-hint filter and a new integration shows up without
// a dashboard release. An earlier draft of this file hardcoded the
// eight known names, from before that endpoint existed.
